import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    Box,
    createStyles, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon,
    IconButton, Input, InputAdornment, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, Theme, Typography
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { InfluencerContext } from '../NewsContext';

import { ClassificationInfluencerModel } from '../../../Models/ClassificationInfluencerModel';
import { HomeContext } from '../../Home/HomeContext';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import { format } from 'date-fns';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import InfluencerService from '../../../Services/InfluencerService';
import { CampaignModel } from '../../../Models/CampaignModel';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        width: '100%',
        color: 'primary',
    },
    itemData: {
        width: '100%',
        color: 'primary',
        paddingBottom: theme.spacing(1.5),

    },
    linkColor: {
        color: '#2C64D0',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    editText: {
        textOverflow: 'ellipsis',
    },
    yellowBackground: {
        backgroundColor: theme.palette.warning.light
    },
    outsideGrid: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loading: {
        minHeight: '20vh'
    },
    linksPaperError: {
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.error.main}`,
    },
    errorText: {
        paddingLeft: theme.spacing(2)
    }
}));
interface NewsDataProps {
    news: CampaignModel | null;
    setNews: (news: CampaignModel) => void;
    newsCurrentId: number | null;
    setNewsCurrentId: (currentId: number | null) => void;
}


export const validarCampos = (news: CampaignModel): ErrosFormulario => {
    const novosErros: ErrosFormulario = {};

    const camposObrigatorios: (keyof CampaignModel)[] = [
        'analiseReputacional',
    ];

    camposObrigatorios.forEach((campo) => {
        if (news) {
            const valor = news[campo];
            if (typeof valor === 'string' && !valor.trim()) {
                novosErros[campo] = 'Campo obrigatório.';
            } else if (valor === null || valor === undefined) {
                novosErros[campo] = 'Campo obrigatório.';
            }
        }
    });
    return novosErros;
};

type ErrosFormulario = Partial<Record<keyof CampaignModel, string>>;
export default function InfluencerCampaignDataReputacao({ news, setNews }: NewsDataProps) {
    const classes = useStyles();

    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [loading, setLoading] = React.useState(false);
    const [erros, setErros] = React.useState<ErrosFormulario>({} as ErrosFormulario);
    const [analiseDisabled, setAnaliseDisabled] = React.useState(true);
    const [analiseFocused, setAnaliseFocused] = React.useState(false);



    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {
                    setFiltersData(res.data);

                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }

    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const handleChange = (prop: keyof ClassificationInfluencerModel) => (event: React.ChangeEvent<HTMLInputElement> | any) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: event.target.value });
    };

    const handleChangeDate = (prop: keyof ClassificationInfluencerModel) =>
        (date: Date | null) => {
            if (date) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                setNews(prevNews => ({
                    ...prevNews,
                    [prop]: date,
                }));
            }
        };

    const handleChangeSelect = (prop: keyof ClassificationInfluencerModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setNews({ ...news, [prop]: event.target.value as string });
        };




    const getAnaliseReputacional = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="AnaliseReputacional"
                        value={news?.analiseReputacional}
                        onChange={handleChange('analiseReputacional')}
                        label="Análise Reputacional"
                        variant="outlined"
                        className={classes.itens}
                        multiline
                        minRows={6}
                        maxRows={6}
                        style={{ marginBottom: 100 }}
                        fullWidth
                        required
                        error={!!erros.analiseReputacional}
                    />
                    {erros.analiseReputacional && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid >
            </>
        );
    };

    const selectNivelRisco = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required error={!!erros.nivelRiscoId && !news?.nivelRiscoId}
                >
                    <Autocomplete
                        id="nivelRisco-autocomplete"
                        options={filters?.nivel_risco ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.nivel_risco?.find(n => n.id_aux === news?.nivelRiscoId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                nivelRiscoId: newValue && typeof newValue.id_aux === 'number' ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Nível de Risco"
                                variant="outlined"
                                error={!!erros.nivelRiscoId && !news?.nivelRiscoId}
                                required
                            />
                        )}
                    />
                    {(erros.nivelRiscoId && !news?.nivelRiscoId) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };



    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {selectNivelRisco()}
                </Grid>
                <Grid item xs={12}>
                    {getAnaliseReputacional()}
                </Grid>
            </Grid>
        </>
    );
}